import React from "react";
import { Formik } from "formik";

export default function FormWrapper({
    initialValues,
    validationSchema,
    onSubmit,
    component,
    validateOnBlur,
    validateOnChange,
    ...additionalProps
}) {
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            validateOnBlur={validateOnBlur}
            validateOnChange={validateOnChange}
            {...additionalProps}
        >
            {component}
        </Formik>
    );
}
